import styled from "styled-components";
const MCQLayoutWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px;
  margin-top: 120px;
  padding-bottom:100px;
  overflow: auto;
  @media (max-width: 768px) {
    margin: 0;
    margin-top: ${({ large }) => large ? '120px' : '110px'};
    padding: 1em 1.5em;
    padding-top:0;
    padding-bottom:50px;
    background-color: white;
    min-height: 100%;
    height: 500px;
    overflow-y: auto;
}
`;
export default MCQLayoutWrapper;